/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/GoalMetricReport', 'model/StrategicProgramCommentPaginationSlice', 'model/StrategicProgramSecondaryOwner', 'model/StrategicProgramStatusUpdateReportPaginationSlice', 'model/StrategyExecutionCustomEntityData', 'model/StrategyExecutionCustomFieldLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./GoalMetricReport'), require('./StrategicProgramCommentPaginationSlice'), require('./StrategicProgramSecondaryOwner'), require('./StrategicProgramStatusUpdateReportPaginationSlice'), require('./StrategyExecutionCustomEntityData'), require('./StrategyExecutionCustomFieldLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicProgramReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.GoalMetricReport, root.ForStractionServiceApi.StrategicProgramCommentPaginationSlice, root.ForStractionServiceApi.StrategicProgramSecondaryOwner, root.ForStractionServiceApi.StrategicProgramStatusUpdateReportPaginationSlice, root.ForStractionServiceApi.StrategyExecutionCustomEntityData, root.ForStractionServiceApi.StrategyExecutionCustomFieldLink);
  }
}(this, function(ApiClient, GoalMetricReport, StrategicProgramCommentPaginationSlice, StrategicProgramSecondaryOwner, StrategicProgramStatusUpdateReportPaginationSlice, StrategyExecutionCustomEntityData, StrategyExecutionCustomFieldLink) {
  'use strict';




  /**
   * The StrategicProgramReport model module.
   * @module model/StrategicProgramReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategicProgramReport</code>.
   * @alias module:model/StrategicProgramReport
   * @class
   */
  var exports = function() {
    var _this = this;



















































  };

  /**
   * Constructs a <code>StrategicProgramReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategicProgramReport} obj Optional instance to populate.
   * @return {module:model/StrategicProgramReport} The populated <code>StrategicProgramReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Metric')) {
        obj['Metric'] = GoalMetricReport.constructFromObject(data['Metric']);
      }
      if (data.hasOwnProperty('Progress')) {
        obj['Progress'] = ApiClient.convertToType(data['Progress'], 'Integer');
      }
      if (data.hasOwnProperty('RiskLevelID')) {
        obj['RiskLevelID'] = ApiClient.convertToType(data['RiskLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('NextUpdateNotificationSendDate')) {
        obj['NextUpdateNotificationSendDate'] = ApiClient.convertToType(data['NextUpdateNotificationSendDate'], 'Date');
      }
      if (data.hasOwnProperty('CustomFieldLinks')) {
        obj['CustomFieldLinks'] = ApiClient.convertToType(data['CustomFieldLinks'], [StrategyExecutionCustomFieldLink]);
      }
      if (data.hasOwnProperty('CustomEntityData')) {
        obj['CustomEntityData'] = ApiClient.convertToType(data['CustomEntityData'], [StrategyExecutionCustomEntityData]);
      }
      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = StrategicProgramCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('StatusUpdates')) {
        obj['StatusUpdates'] = StrategicProgramStatusUpdateReportPaginationSlice.constructFromObject(data['StatusUpdates']);
      }
      if (data.hasOwnProperty('SecondaryOwners')) {
        obj['SecondaryOwners'] = ApiClient.convertToType(data['SecondaryOwners'], [StrategicProgramSecondaryOwner]);
      }
      if (data.hasOwnProperty('CanUserAddProgram')) {
        obj['CanUserAddProgram'] = ApiClient.convertToType(data['CanUserAddProgram'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserEditProgram')) {
        obj['CanUserEditProgram'] = ApiClient.convertToType(data['CanUserEditProgram'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserAddFreeNode')) {
        obj['CanUserAddFreeNode'] = ApiClient.convertToType(data['CanUserAddFreeNode'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserEditMetrics')) {
        obj['CanUserEditMetrics'] = ApiClient.convertToType(data['CanUserEditMetrics'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserMakeStatusUpdate')) {
        obj['CanUserMakeStatusUpdate'] = ApiClient.convertToType(data['CanUserMakeStatusUpdate'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserActivateProgram')) {
        obj['CanUserActivateProgram'] = ApiClient.convertToType(data['CanUserActivateProgram'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserCloseProgram')) {
        obj['CanUserCloseProgram'] = ApiClient.convertToType(data['CanUserCloseProgram'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserEditDescriptions')) {
        obj['CanUserEditDescriptions'] = ApiClient.convertToType(data['CanUserEditDescriptions'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserAddSubProgram')) {
        obj['CanUserAddSubProgram'] = ApiClient.convertToType(data['CanUserAddSubProgram'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserAddMilestone')) {
        obj['CanUserAddMilestone'] = ApiClient.convertToType(data['CanUserAddMilestone'], 'Boolean');
      }
      if (data.hasOwnProperty('ProgressUpdatesAvailable')) {
        obj['ProgressUpdatesAvailable'] = ApiClient.convertToType(data['ProgressUpdatesAvailable'], 'Boolean');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('FunctionID')) {
        obj['FunctionID'] = ApiClient.convertToType(data['FunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('OwnerUserID')) {
        obj['OwnerUserID'] = ApiClient.convertToType(data['OwnerUserID'], 'Integer');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategySelectionID')) {
        obj['StrategySelectionID'] = ApiClient.convertToType(data['StrategySelectionID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('RoadmapStartDate')) {
        obj['RoadmapStartDate'] = ApiClient.convertToType(data['RoadmapStartDate'], 'Date');
      }
      if (data.hasOwnProperty('RoadmapEndDate')) {
        obj['RoadmapEndDate'] = ApiClient.convertToType(data['RoadmapEndDate'], 'Date');
      }
      if (data.hasOwnProperty('UpdateFrequencyID')) {
        obj['UpdateFrequencyID'] = ApiClient.convertToType(data['UpdateFrequencyID'], 'Integer');
      }
      if (data.hasOwnProperty('LastUpdateDate')) {
        obj['LastUpdateDate'] = ApiClient.convertToType(data['LastUpdateDate'], 'Date');
      }
      if (data.hasOwnProperty('LastUpdateNotificationSentDate')) {
        obj['LastUpdateNotificationSentDate'] = ApiClient.convertToType(data['LastUpdateNotificationSentDate'], 'Date');
      }
      if (data.hasOwnProperty('RoadmapEnabled')) {
        obj['RoadmapEnabled'] = ApiClient.convertToType(data['RoadmapEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('ParentMilestoneID')) {
        obj['ParentMilestoneID'] = ApiClient.convertToType(data['ParentMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('DateClosed')) {
        obj['DateClosed'] = ApiClient.convertToType(data['DateClosed'], 'Date');
      }
      if (data.hasOwnProperty('FinalStatusID')) {
        obj['FinalStatusID'] = ApiClient.convertToType(data['FinalStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('FinalStatusComment')) {
        obj['FinalStatusComment'] = ApiClient.convertToType(data['FinalStatusComment'], 'String');
      }
      if (data.hasOwnProperty('CustomLabel')) {
        obj['CustomLabel'] = ApiClient.convertToType(data['CustomLabel'], 'String');
      }
      if (data.hasOwnProperty('SendStatusUpdateNotifications')) {
        obj['SendStatusUpdateNotifications'] = ApiClient.convertToType(data['SendStatusUpdateNotifications'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('NoProgressTracking')) {
        obj['NoProgressTracking'] = ApiClient.convertToType(data['NoProgressTracking'], 'Boolean');
      }
      if (data.hasOwnProperty('ProgressCalculationMethodID')) {
        obj['ProgressCalculationMethodID'] = ApiClient.convertToType(data['ProgressCalculationMethodID'], 'Integer');
      }
      if (data.hasOwnProperty('ProgressCalculationSourceID')) {
        obj['ProgressCalculationSourceID'] = ApiClient.convertToType(data['ProgressCalculationSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectedToMilestoneID')) {
        obj['ConnectedToMilestoneID'] = ApiClient.convertToType(data['ConnectedToMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectedToProgramID')) {
        obj['ConnectedToProgramID'] = ApiClient.convertToType(data['ConnectedToProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectableAggregationTarget')) {
        obj['ConnectableAggregationTarget'] = ApiClient.convertToType(data['ConnectableAggregationTarget'], 'Boolean');
      }
      if (data.hasOwnProperty('SecondaryStatusUpdateTypeID')) {
        obj['SecondaryStatusUpdateTypeID'] = ApiClient.convertToType(data['SecondaryStatusUpdateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/GoalMetricReport} Metric
   */
  exports.prototype['Metric'] = undefined;
  /**
   * @member {Integer} Progress
   * @default 0
   */
  exports.prototype['Progress'] = 0;
  /**
   * @member {Integer} RiskLevelID
   */
  exports.prototype['RiskLevelID'] = undefined;
  /**
   * @member {Date} NextUpdateNotificationSendDate
   */
  exports.prototype['NextUpdateNotificationSendDate'] = undefined;
  /**
   * @member {Array.<module:model/StrategyExecutionCustomFieldLink>} CustomFieldLinks
   */
  exports.prototype['CustomFieldLinks'] = undefined;
  /**
   * @member {Array.<module:model/StrategyExecutionCustomEntityData>} CustomEntityData
   */
  exports.prototype['CustomEntityData'] = undefined;
  /**
   * @member {module:model/StrategicProgramCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {module:model/StrategicProgramStatusUpdateReportPaginationSlice} StatusUpdates
   */
  exports.prototype['StatusUpdates'] = undefined;
  /**
   * @member {Array.<module:model/StrategicProgramSecondaryOwner>} SecondaryOwners
   */
  exports.prototype['SecondaryOwners'] = undefined;
  /**
   * @member {Boolean} CanUserAddProgram
   * @default false
   */
  exports.prototype['CanUserAddProgram'] = false;
  /**
   * @member {Boolean} CanUserEditProgram
   * @default false
   */
  exports.prototype['CanUserEditProgram'] = false;
  /**
   * @member {Boolean} CanUserAddFreeNode
   * @default false
   */
  exports.prototype['CanUserAddFreeNode'] = false;
  /**
   * @member {Boolean} CanUserEditMetrics
   * @default false
   */
  exports.prototype['CanUserEditMetrics'] = false;
  /**
   * @member {Boolean} CanUserMakeStatusUpdate
   * @default false
   */
  exports.prototype['CanUserMakeStatusUpdate'] = false;
  /**
   * @member {Boolean} CanUserActivateProgram
   * @default false
   */
  exports.prototype['CanUserActivateProgram'] = false;
  /**
   * @member {Boolean} CanUserCloseProgram
   * @default false
   */
  exports.prototype['CanUserCloseProgram'] = false;
  /**
   * @member {Boolean} CanUserEditDescriptions
   * @default false
   */
  exports.prototype['CanUserEditDescriptions'] = false;
  /**
   * @member {Boolean} CanUserAddSubProgram
   * @default false
   */
  exports.prototype['CanUserAddSubProgram'] = false;
  /**
   * @member {Boolean} CanUserAddMilestone
   * @default false
   */
  exports.prototype['CanUserAddMilestone'] = false;
  /**
   * @member {Boolean} ProgressUpdatesAvailable
   * @default false
   */
  exports.prototype['ProgressUpdatesAvailable'] = false;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} FunctionID
   */
  exports.prototype['FunctionID'] = undefined;
  /**
   * @member {Integer} OwnerUserID
   * @default 0
   */
  exports.prototype['OwnerUserID'] = 0;
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} StrategySelectionID
   */
  exports.prototype['StrategySelectionID'] = undefined;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Date} RoadmapStartDate
   */
  exports.prototype['RoadmapStartDate'] = undefined;
  /**
   * @member {Date} RoadmapEndDate
   */
  exports.prototype['RoadmapEndDate'] = undefined;
  /**
   * @member {Integer} UpdateFrequencyID
   * @default 0
   */
  exports.prototype['UpdateFrequencyID'] = 0;
  /**
   * @member {Date} LastUpdateDate
   */
  exports.prototype['LastUpdateDate'] = undefined;
  /**
   * @member {Date} LastUpdateNotificationSentDate
   */
  exports.prototype['LastUpdateNotificationSentDate'] = undefined;
  /**
   * @member {Boolean} RoadmapEnabled
   * @default false
   */
  exports.prototype['RoadmapEnabled'] = false;
  /**
   * @member {Integer} ParentMilestoneID
   * @default 0
   */
  exports.prototype['ParentMilestoneID'] = 0;
  /**
   * @member {Date} DateClosed
   */
  exports.prototype['DateClosed'] = undefined;
  /**
   * @member {Integer} FinalStatusID
   */
  exports.prototype['FinalStatusID'] = undefined;
  /**
   * @member {String} FinalStatusComment
   * @default ''
   */
  exports.prototype['FinalStatusComment'] = '';
  /**
   * @member {String} CustomLabel
   * @default ''
   */
  exports.prototype['CustomLabel'] = '';
  /**
   * @member {Boolean} SendStatusUpdateNotifications
   * @default false
   */
  exports.prototype['SendStatusUpdateNotifications'] = false;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Boolean} NoProgressTracking
   * @default false
   */
  exports.prototype['NoProgressTracking'] = false;
  /**
   * @member {Integer} ProgressCalculationMethodID
   * @default 0
   */
  exports.prototype['ProgressCalculationMethodID'] = 0;
  /**
   * @member {Integer} ProgressCalculationSourceID
   */
  exports.prototype['ProgressCalculationSourceID'] = undefined;
  /**
   * @member {Integer} ConnectedToMilestoneID
   */
  exports.prototype['ConnectedToMilestoneID'] = undefined;
  /**
   * @member {Integer} ConnectedToProgramID
   */
  exports.prototype['ConnectedToProgramID'] = undefined;
  /**
   * @member {Boolean} ConnectableAggregationTarget
   * @default false
   */
  exports.prototype['ConnectableAggregationTarget'] = false;
  /**
   * @member {Integer} SecondaryStatusUpdateTypeID
   * @default 0
   */
  exports.prototype['SecondaryStatusUpdateTypeID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


